import ContainerMyProfile from "../../Component/Profile/MyProfile"

const MyProfilePage = () => {
  return (
    <div className='page-body'>
      <ContainerMyProfile />
    </div>
  )
}

export default MyProfilePage